// Toast
import store from 'app/store';
import AppToast from 'general/components/AppToast';
import { Suspense, useEffect } from 'react';
import 'react-toastify/dist/ReactToastify.css';
// router
import GuestRoute from 'general/components/AppRoutes/GuestRoute';
import PrivateRoute, { LoginRoute } from 'general/components/AppRoutes/PrivateRoute';
import KTPageError01 from 'general/components/OtherKeenComponents/KTPageError01';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Saymee from 'modules/Saymee';
import SignInScreen from 'modules/Saymee/features/Auth/screens/SignIn';
import { QueryClient, QueryClientProvider } from 'react-query';
import { notification } from 'antd';

// Load BS
// Load KT plugins
require('assets/plugins/ktutil');
require('assets/plugins/ktmenu');
require('assets/plugins/ktoffcanvas');
require('assets/plugins/ktcookie');
require('assets/plugins/kttoggle');
// aside
require('assets/plugins/aside/aside');
require('assets/plugins/aside/aside-menu');
require('assets/plugins/aside/aside-toggle');
// header
require('assets/plugins/header/ktheader-mobile');
require('assets/plugins/header/ktheader-topbar');

window.$ = window.jQuery = require('jquery');
window.moment = require('moment');

const sTag = '[App]';

function App() {
  // MARK: --- Hooks ---
  useEffect(() => {
    console.log(`${sTag} did load`);

    return () => {
      console.log(`${sTag} will dismiss`);
    };
  }, []);

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        refetchOnWindowFocus: false,
        onError: error => {
          console.log(error)
          notification.error({ message: error.data?.message || 'Có lỗi xảy ra vui lòng thử lại sau!' });
        }
      }
    }
  });

  return (
    <>
      <QueryClientProvider client={queryClient}>
        {/* Router */}
        <BrowserRouter>
          {/* Suspense */}
          <Suspense fallback={<div>Loading...</div>}>
            <Routes>
              <Route path="/" element={<LoginRoute></LoginRoute>} />
              <Route path='/signin'
                element={<SignInScreen />}
              />
              <Route
                path="/LichViet/*"
                element={
                  <PrivateRoute>
                    <Saymee />
                  </PrivateRoute>
                }
              />
              <Route path="*" element={<KTPageError01 />} />
            </Routes>
          </Suspense>
        </BrowserRouter>

        {/* Toast */}
        <AppToast />
      </QueryClientProvider>
    </>
  );
}

export default App;
